import { CommonModule, DecimalPipe } from '@angular/common';
import {
    Component,
    ElementRef,
    HostListener,
    inject,
    signal,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FilterGlobalComponent } from 'app/components/filter-global/filter-global.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { SortByGeneralComponent } from 'app/components/sort-by-general/sort-by-general.component';
import { ApplicationService } from 'app/services/application.service';
import { isEmpty, isEmptyObj, parseJSON } from 'app/shared/utils';
import { InputSelectGeneralComponent } from 'app/components/input-select-general/input-select-general.component';
import { branchesData } from 'app/data/branches-data';
import { MatIconModule } from '@angular/material/icon';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { FilterSortbyDialogComponent } from 'app/components/filter-sortby-dialog/filter-sortby-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatRadioModule } from '@angular/material/radio';
import { SelectBranchPopupComponent } from './select-branch-popup/select-branch-popup.component';
import { SelectOfficerPopupComponent } from './select-officer-popup/select-officer-popup.component';
import { MatDividerModule } from '@angular/material/divider';
import { ApplicationStepperComponent } from 'app/components/application-stepper/application-stepper.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ApplicationDashboardService } from 'app/application/services/application-dashboard.service';
import { lastValueFrom, map } from 'rxjs';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductSelectionTabComponent } from './product-selection-tab/product-selection-tab.component';
import { NoMatchComponent } from './no-match/no-match.component';
import { NoMatchProductsComponent } from './no-match-products/no-match-products.component';
import { NoMatchFinancialAdvisoryComponent } from './no-match-financial-advisory/no-match-financial-advisory.component';
import { ReminderPopupComponent } from './reminder-popup/reminder-popup.component';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
@Component({
    selector: 'app-matched-products',
    templateUrl: './matched-products.component.html',
    styleUrls: ['./matched-products.component.scss'],
    imports: [
        HeaderComponent,
        FooterComponent,
        CommonModule,
        RouterModule,
        TranslateModule,
        FilterGlobalComponent,
        SortByGeneralComponent,
        InputSelectGeneralComponent,
        LoaderComponent,
        MatIconModule,
        FilterSortbyDialogComponent,
        MatRadioModule,
        MatDividerModule,
        ApplicationStepperComponent,
        MatExpansionModule,
        MatCardModule,
        SlickCarouselModule,
        ProductCardComponent,
        ProductSelectionTabComponent,
        NoMatchComponent,
        NoMatchProductsComponent,
        NoMatchFinancialAdvisoryComponent,
        DecimalPipe,
    ],
    standalone: true,
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class MatchedProductsComponent {
    bankProductsTotal;
    P2P_ProductsTotal;
    DigitalBanks_ProductsTotal;
    productName: string;
    selectedLanguage: any;
    selectedSortBy = -1;
    clickedOutside: boolean = false;
    isFilterOpen: boolean = false;
    isSortbyOpen: boolean = false;
    apiResponse = false;
    statusCode: number;
    caseId: any;
    prodCode: any;
    isAuthenticated: boolean = false;
    selectBranchError;
    selectBranchErrorBRP;
    selectOfficerError;
    closeTostr: string;
    disableSubmitBtn: boolean = false;
    selectedProducts = [];
    selectedProductsCGC = [];
    matchedProductsList: any = [];
    matchedProductsData = [];
    matchedProductsTotal = 0;
    matchedp2pProdTotal = 0;
    productMinMaxError: string;
    maxBankSelectionError: string;
    selectfAOrP2P: string;
    filteredProducts = [];
    initialMatchedProductsList = [];
    sortOptions = [];
    disableIslamicFilter: boolean = false;
    disableConventionalFilter: boolean = false;
    selectedBranchIndex: number | null = null;
    checkboxStates: { [key: string]: boolean } = {};
    checkBox = [];
    prodArr = [];
    selectedProductsMsg: string;
    selectedfiId: any;
    recomProdList: any = [];
    recomDigitalBankList: any = [];
    isRecommended: boolean = false;
    fASelected: boolean = false;
    limitExceeded: boolean = false;
    isBranchChanged: any;
    fromResume: any;
    UniquebranchArray: any[] = [];
    branchArray: any[] = [];
    isBranchSelect: boolean = false;
    getCaseStatusResponse: boolean = false;
    duplicateProdCode: any[] = [];
    duplicateP2pProdCode: any[] = [];
    statusOptions = [
        'Referred',
        'Application Submission',
        'Approval',
        'Customer Acceptance',
        'Disbursement',
        'P2P Hosting',
    ];
    selectedBranchOfficerId: number;
    selectedBranchOfficerName: string;
    selectedBranchOfficerUserName: string;
    selectedBranchOfficerEmail: string;
    selectedBranchEmail: string;
    selectedBranchCode: string;
    bkData: any;
    regBrnNum: any = [];
    noAvailableOptions: boolean = false;

    isBRPFlow: boolean = false;
    isBRPNoMatchFlow: boolean = false;
    isBRP_CGC_Flow: boolean = false;
    isCIDBFlow: boolean = false;
    isCIDBNoMatchFlow: boolean = false;
    isCGCFlow: boolean = false;
    noMatchedProducts: boolean = false;

    submitGAEventId: string = '';
    submitGAEventCategory: string = '';
    submitGAEventLabel: string = '';

    brpBranchesList = [];
    selectedBrpBranches: any;
    selectedBrpOfficers: any;
    p2pProducts: any[] = [];
    continueWithoutProdRec: boolean = false;
    recommendMinProdSelectionRes: boolean;
    @ViewChild('filterDropdown') filterDropdownRef!: ElementRef;
    @ViewChild('noProductsOnFilter') noProductsOnFilter!: ElementRef;
    initialMatchedProdTotal: number;

    handleDirectorChange(i: number, j: number) {
        if (this.matchedProductsList[i].disableRadioBtns) return;
        this.matchedProductsList[i].selectedBranchIndex = j;
        let changeTheSelectedIndex = this.selectedProductsCGC.findIndex(
            (item) => item.prodCode === this.matchedProductsList[i].prodCode,
        );
        if (changeTheSelectedIndex > -1) {
            this.selectedProductsCGC[changeTheSelectedIndex].selectedBranch =
                this.branches[j].name;
            this.isValidSelection();
        }
    }
    branches = branchesData;
    imgRetries: number = 0;
    selection;

    dialogRef = inject(MatDialog);
    selectedBranchName;
    selectedBranchData;
    selectedBranchId;
    isBranchFromSameProduct: boolean = false;

    disableSaveDraft = false;
    saveDraftMsg;
    selectedProductsDocsCond = [];

    value = 65;
    panelOpenState = signal(true);
    currentSlide: number = 0;
    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    rightSide = [
        {
            title: 'RIGHT_DIV.TITLE_1',
            subtitle: 'RIGHT_DIV.SUBTITLE_1',
        },
        {
            title: 'RIGHT_DIV.TITLE_2',
            subtitle: 'RIGHT_DIV.SUBTITLE_2',
        },
        {
            title: 'RIGHT_DIV.TITLE_3',
            subtitle: 'RIGHT_DIV.SUBTITLE_3',
        },
    ];

    constructor(
        private router: Router,
        private translate: TranslateService,
        private applicationService: ApplicationService,
        private _dashboardService: ApplicationDashboardService,
        public dialog: MatDialog,
        private vcr: ViewContainerRef,
        private toastr: ToastrService,
    ) {
        this.selectedLanguage = localStorage.getItem('language');
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        if (this.isAuthenticated == false) {
            this.router.navigate(['/login']);
        }

        const navigationState = this.router.getCurrentNavigation().extras.state;

        this.apiResponse = navigationState?.apiResponse;
        this.statusCode = navigationState?.statusCode;
        this.caseId = navigationState?.caseId;
        this.regBrnNum = navigationState?.regNoo;
        this.fromResume = navigationState?.fromResume;

        let source = navigationState?.source;
        if (source == 'CGC') {
            this.isCGCFlow = true;
        } else if (source == 'CIDB') {
            this.isCIDBFlow = true;
        } else if (source == 'BRP' || source?.includes('CGC-')) {
            this.isBRPFlow = true;
        }

        if (!this.statusCode || this.statusCode == 200) {
            this.applicationService.checkCaseIdForRedirection(this.caseId);
            this.matchedProductsData = navigationState?.matchedProductsData;
            this.productName = navigationState?.productName;
            this.prodCode = navigationState?.prodCode;
        }
    }

    // after selecting from filter if anywhere elese clicked then filter should be closed
    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {}

    @HostListener('document:click', ['$event.target'])
    onClickOutside(targetElement: HTMLElement) {
        const clickedInside =
            this?.filterDropdownRef?.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.isFilterOpen = false;
        }
    }

    ngOnInit() {
        //check for duplicate application
        this.getProductRecommendations();
        this.getTranslations();
    }

    setupGAEvents() {
        if (this.noMatchedProducts) {
            this.submitGAEventId = 'confirm_selection_no_product_match_click';
            this.submitGAEventCategory = 'No Product Match Button';
            this.submitGAEventLabel = 'Confirm Selection Button';
        } else if (!this.noMatchedProducts) {
            this.submitGAEventId =
                'confirm_selection_button_matched_prodp_click';
            this.submitGAEventCategory = 'Matched Products Page Button';
            this.submitGAEventLabel = 'Next Step Application Button Click';
        }
    }

    getTranslations() {
        this.translate
            .get('ERROR.PRODUCT_MIN_MAX_SELECTION')
            .subscribe((data: any) => {
                this.productMinMaxError = data;
            });
        this.translate
            .get('ERROR.MAX_BANK_SELECTION')
            .subscribe((data: any) => {
                this.maxBankSelectionError = data;
            });
        this.translate
            .get('PRODUCT_MATCHING.PRODUCTS_SELECTED_TOTAL')
            .subscribe((data: any) => {
                this.selectedProductsMsg = data;
            });
        this.translate
            .get('PRODUCT_MATCHING.SELECT_BRANCH_ERROR')
            .subscribe((data: any) => {
                this.selectBranchError = data;
            });
        this.translate
            .get('PRODUCT_MATCHING.SELECT_BRANCH_ERROR_BRP')
            .subscribe((data: any) => {
                this.selectBranchErrorBRP = data;
            });
        this.translate
            .get('PRODUCT_MATCHING.SELECT_OFFICER_ERROR')
            .subscribe((data: any) => {
                this.selectOfficerError = data;
            });
        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });
        this.translate
            .get('NEW_APPLICATION.BUSINESS_INFO_SAVE_DRAFT_MSG')
            .subscribe((data: any) => {
                this.saveDraftMsg = data;
            });
        this.translate.get('ERROR.SELECT_FA_OR_P2P').subscribe((data: any) => {
            this.selectfAOrP2P = data;
        });
    }

    onSelectBranchBRP = () => {
        //To open popup which shows list of officers for BRP product
        const dialogRef = this.dialogRef.open(SelectOfficerPopupComponent, {
            panelClass: 'select-officer-popup',
            data: {
                brpBranchesList: this.brpBranchesList,
                selectedBrpBranches: this.selectedBrpBranches,
                selectedBrpOfficers: this.selectedBrpOfficers,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.selectedBrpBranches) {
                this.selectedBrpBranches = result.selectedBrpBranches;
                this.selectedBrpOfficers = result.selectedBrpOfficers;
            }
        });
    };

    showDialog = (productDetails) => {
        //To open popup which shows list of branches of bank for a product
        const currProd = productDetails?.prodNameList?.at(0);
        const { isRecProd } = productDetails;
        const dialogRef = this.dialogRef.open(SelectBranchPopupComponent, {
            panelClass: 'select-branch-popup',
            data: {
                productDetails: productDetails,
                selectedBranchId: this.selectedBranchId,
                selectedProducts: this.selectedProducts,
                selectedBranchName: this.selectedBranchName,
                selectedBranchOfficerId: this.selectedBranchOfficerId,
                selectedBranchOfficerName: this.selectedBranchOfficerName,
                selectedBranchOfficerEmail: this.selectedBranchOfficerEmail,
                selectedBranchEmail: this.selectedBranchEmail,
                branch: this.onBranchSelect(productDetails?.fiId, ''),
                branchId: this.onBranchSelect(productDetails?.fiId, 'branchId'),
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.data) {
                this.bkData = result?.data;
                this.isBranchSelect = true;
                this.selectedBranchName = result?.data?.branchName;
                this.selectedBranchCode = result?.data?.branchCode;
                this.selectedBranchId = result?.data?.branchId;
                this.selectedfiId = result?.data?.fiId;
                this.isBranchChanged = result?.data?.isBranchChanged
                    ? result?.data?.isBranchChanged
                    : false;
                this.selectedBranchOfficerId = result?.data?.officerId;
                this.selectedBranchOfficerName = result?.data?.officerName;
                this.selectedBranchOfficerUserName =
                    result?.data?.officerUsername;
                this.selectedBranchOfficerEmail = result?.data?.officerEmail;
                this.selectedBranchEmail = result?.data?.branchEmail;
                let isOfficerChanged = result?.data?.isOfficerChanged
                    ? result?.data?.isOfficerChanged
                    : false;
                if (this.isBranchChanged) {
                    //if branch changed then all products will be deselected
                    let prodCode = result?.data?.prodCode;
                    this.isProductSelected(prodCode, this.isBranchChanged);
                    this.selectedProducts = this.selectedProducts.filter(
                        (item) => !prodCode.includes(item.prodCode),
                    );
                    this.prodArr = this.prodArr.filter(
                        (item) => !prodCode.includes(item),
                    );
                }
                const selectedBranchData = {
                    fiId: this.selectedfiId,
                    branchName: this.selectedBranchName,
                    branchCode: this.selectedBranchCode,
                    branchId: this.selectedBranchId,
                    branchEmail: this.selectedBranchEmail,
                    officerName: this.selectedBranchOfficerName,
                    officerUsername: this.selectedBranchOfficerUserName,
                };
                this.branchArray?.push(selectedBranchData);
                if (this.UniquebranchArray) {
                    const index = this.UniquebranchArray.findIndex(
                        (item) => item.fiId === this.selectedfiId,
                    );
                    if (selectedBranchData) {
                        index !== -1
                            ? (this.UniquebranchArray[index] =
                                  selectedBranchData)
                            : this.UniquebranchArray.push(selectedBranchData);
                    } else if (index !== -1) {
                        this.UniquebranchArray.splice(index, 1);
                    }
                }
                if (isRecProd && this.isCGCFlow) {
                    //if user selects recommended product first time for the bank product
                    if (!this.isBranchChanged && !isOfficerChanged) {
                        this.onSelectProduct(
                            { target: { checked: true } },
                            currProd.prodCode,
                            productDetails,
                            currProd?.prodCat,
                        );
                    }
                }
            }
        });
    };

    recommendedProductSelect(recommendedProductDetails) {
        const { prodCode, isSelected, productDetails, prodCat } =
            recommendedProductDetails;
        if (isSelected) {
            this.onSelectProduct(
                { target: { checked: true } },
                prodCode,
                productDetails,
                prodCat,
            );
        } else if (!isSelected) {
            this.onSelectProduct(
                { target: { checked: false } },
                prodCode,
                productDetails,
                prodCat,
            );
        }
    }

    handleChangeBranch(prodDetails) {
        const res = this.onBranchSelect(prodDetails?.fiId, '');
        return res;
    }

    onSelectProduct(event, prodCode, prodDetails, prodCat?) {
        let isChecked = event.target.checked;
        if (isChecked) {
            this.prodArr.push(prodCode);
        } else if (!isChecked) {
            const temp = this.prodArr.filter((item) => item !== prodCode);
            this.prodArr = temp;
        }
        this.selectedBranchData = this.onBranchSelect(prodDetails.fiId, '');
        this.selectedBranchName = this.selectedBranchData;
        this.selectedfiId = prodDetails.fiId;
        let selectedBranchId;
        let selectedBranchName;
        let selectedOfficerName;
        let selectedOfficerUserName;
        let selectedOfficerEmail;
        let selectedOfficerId;
        let selectedBranchCode;
        let selectedBranchEmail;
        if (prodDetails.branchActive === 'Y')
            prodDetails.branchListing.map((element) => {
                if (element.branchName == this.selectedBranchData) {
                    selectedBranchName = element.branchName;
                    selectedBranchId = this.selectedBranchId;
                    selectedOfficerId = this.selectedBranchOfficerId;
                    selectedOfficerName = this.selectedBranchOfficerName;
                    selectedOfficerEmail = this.selectedBranchOfficerEmail;
                    selectedOfficerUserName =
                        this.selectedBranchOfficerUserName;
                    selectedBranchCode = this.selectedBranchCode;
                    this.isBranchFromSameProduct = true;
                }
            });

        if (isChecked) {
            if (this.isBRPFlow && isEmptyObj(this.selectedBrpBranches)) {
                event.target.checked = false;
                this.toastr.error(this.selectBranchErrorBRP);
                return;
            }

            if (
                prodDetails.branchActive === 'Y' &&
                this.isBRP_CGC_Flow == false
            ) {
                if (!this.selectedBranchName) {
                    event.target.checked = false;
                    this.prodArr.pop();
                    this.toastr.error(this.selectBranchError);
                    return;
                } else if (
                    this.selectedBranchName &&
                    this.selectedfiId &&
                    prodDetails.fiId !== this.selectedfiId
                ) {
                    event.target.checked = false;
                    this.toastr.error(
                        'Please select branch first to select the product',
                    );
                    return;
                }
            }

            if (prodDetails.fiProd == 'IFBU') {
                if (!this.isBRPFlow) {
                    selectedBranchEmail = this.selectedBranchEmail;
                }
            }

            this.selectedProducts.push({
                prodCode: prodCode,
                branchName: selectedBranchName,
                isBranchActive: prodDetails.branchActive,
                checked: isChecked,
                uploadDocs: prodDetails.uploadDocs,
                fiId: prodDetails.fiId,
                fiProd: prodDetails.fiProd,
                prodCat: prodCat,
                prodDetails: prodDetails,
                branchId: selectedBranchId,
                officerId: selectedOfficerId,
                officerUserName: selectedOfficerUserName,
                officerName: selectedOfficerName,
                officerEmail: selectedOfficerEmail,
                branchCode: selectedBranchCode,
                branchEmail: selectedBranchEmail,
            });
        } else {
            this.selectedProducts = this.selectedProducts.filter((product) => {
                return product.prodCode !== prodCode;
            });

            const isProdAvailable = this.selectedProducts.some(
                (data) => data.branchName === this.selectedBranchName,
            );
            if (!isProdAvailable) {
                this.UniquebranchArray = this.UniquebranchArray.filter(
                    (branch) => branch.fiId !== prodDetails.fiId,
                );
            }

            if (!this.selectedProducts.length) {
                this.selectedBranchName = null;
                this.selectedBranchId = null;
            }
        }
        //show msg for total products selected out of 3
        this.showTotalSelectedProducts(this.selectedProducts.length);
        let P2P_ProductsTotal = this.selectedProducts.filter((item) => {
            if (item.prodCat == 'P2P') return item.prodCat;
        });
        this.P2P_ProductsTotal = P2P_ProductsTotal.length;

        // For DISPLAY: Show Digital Bank as separate category
        let DigitalBanks_ProductsTotal = this.selectedProducts.filter(
            (item) => {
                if (item.prodCat == 'DIGITAL BANK') return item.prodCat;
            },
        );
        this.DigitalBanks_ProductsTotal = DigitalBanks_ProductsTotal.length;

        // For DISPLAY: Show only traditional Bank + CGC products (excluding Digital Bank)
        let bankProductsTotal = this.selectedProducts.filter((item) => {
            if (item.prodCat == 'BANK' || item.prodCat == 'CGC')
                return item.prodCat;
        });
        this.bankProductsTotal = bankProductsTotal.length;

        this.limitExceeded = this.selectedProducts.length > 5;
    }

    showTotalSelectedProducts(selectedProductsLength) {
        let selectedProductsTotal = selectedProductsLength;
        this.toastr.success(selectedProductsTotal + this.selectedProductsMsg);
    }

    isProductSelected(prodCode, isBranchChanged?) {
        if (prodCode.length > 0 && isBranchChanged) {
            return (
                this.selectedProducts.find(
                    (item) => prodCode.includes(item.prodCode) && item.checked,
                ) !== undefined
            );
        } else {
            return (
                this.selectedProducts.find(
                    (item) => item.prodCode === prodCode && item.checked,
                ) !== undefined
            );
        }
    }

    onBranchSelect(fiId: number, str: string) {
        if (!fiId || !this.UniquebranchArray) return '';
        const branch = this.UniquebranchArray.find(
            (item) => item.fiId === fiId,
        );
        if (!branch) return '';
        return str === 'branchId' ? branch.branchId : branch.branchName;
    }

    openFilterSortByDialog() {
        this.dialog.open(FilterSortbyDialogComponent, {
            hasBackdrop: true,
            panelClass: 'filter-sortby-dialog',
            backdropClass: 'filter-sortby-dialog-background',
            scrollStrategy: new NoopScrollStrategy(),
            position: { top: '26px' },
            data: {
                checkboxState: this.checkboxStates,
                onFilterProduct: (event, prodCategory) =>
                    this.onFilterProduct(event, prodCategory),
                onSortProduct: (number) => this.onSortProduct(number),
                selectedSortBy: this.selectedSortBy,
            },
        });
    }

    async getCaseStatus(directorNric, regNo, constitutionTypeStdCode) {
        return await lastValueFrom(
            this._dashboardService.caseStatus().pipe(
                map((response) => {
                    if (response) {
                        response.forEach((caseData) => {
                            let isDuplicateStatus = this.statusOptions.includes(
                                caseData.cCaseStatus,
                            );
                            if (isDuplicateStatus) {
                                if (
                                    directorNric == caseData.cCaseNric &&
                                    constitutionTypeStdCode ===
                                        caseData.cCaseBizConst
                                ) {
                                    if (regNo) {
                                        if (
                                            regNo == caseData.cCaseBizRegNo ||
                                            regNo == caseData.cCaseOldBizRegNo
                                        ) {
                                            this.duplicateProdCode.push(
                                                caseData.cCaseProdSel,
                                            );
                                        }
                                    } else if (!regNo) {
                                        this.duplicateProdCode.push(
                                            caseData.cCaseProdSel,
                                        );
                                    }
                                }
                            }
                        });
                    } else {
                        throw new Error('Something went wrong!');
                    }
                }),
            ),
        );
    }
    async getP2pCaseStatus(regNo) {
        return await lastValueFrom(
            this._dashboardService.caseStatus().pipe(
                map((response) => {
                    if (response) {
                        response.forEach((caseData) => {
                            // Check if the case status should hide the P2P product
                            let shouldHideProduct = this.statusOptions.includes(
                                caseData.cCaseStatus,
                            );

                            if (shouldHideProduct) {
                                if (regNo) {
                                    if (
                                        regNo == caseData.cCaseBizRegNo ||
                                        regNo == caseData.cCaseOldBizRegNo
                                    ) {
                                        this.duplicateP2pProdCode.push(
                                            caseData.cCaseProdSel,
                                        );
                                    }
                                }
                            }
                        });
                    } else {
                        throw new Error('Something went wrong!');
                    }
                }),
            ),
        );
    }

    async getProductRecommendations() {
        // Reset duplicate product codes arrays and totals at the beginning
        this.duplicateProdCode = [];
        this.duplicateP2pProdCode = [];
        this.matchedp2pProdTotal = 0;

        if (this.statusCode === 200) {
            for (const element of this.matchedProductsData) {
                let directorNric = element.directorNric;
                let regNo = element.regNo;
                let constitutionTypeStdCode = element.constitutionTypeStdCode;
                await this.getCaseStatus(
                    directorNric,
                    regNo,
                    constitutionTypeStdCode,
                );
                if (this.isBRPFlow) {
                    if (element.defaultBranch?.length) {
                        if (element?.prodMatchList?.length) {
                            // this.isBRPFlow = true;
                            this.brpBranchesList = element.defaultBranch;
                        } else {
                            //BRP has no data (show old no-match)
                            this.isBRPNoMatchFlow = true;
                            this.isBRPFlow = false;
                        }
                    }
                }
                this.matchedProductsList = element?.prodMatchList;
                this.matchedProductsList.forEach((element) => {
                    if (element.fiProd == 'IFBU' && this.isBRPFlow) {
                        //Belongs to CGC product
                        this.isBRP_CGC_Flow = true;
                    }
                    let prodTagFormat = element.prodNameList;
                    prodTagFormat.forEach((element) => {
                        if (element.prodTag !== null) {
                            prodTagFormat = parseJSON(element.prodTag);
                            if (prodTagFormat.includes('BRP')) {
                                prodTagFormat = prodTagFormat.filter((item) => {
                                    return item !== 'BRP';
                                });
                            }
                            return (element.prodTag = prodTagFormat);
                        }
                    });
                    element.showMore = false;
                    element.selectedBranchIndex = null;
                    element.disableRadioBtns = true;
                    //get products that are not already applied by user
                    let getNonDuplicateProducts = element.prodNameList.filter(
                        (item) => {
                            // Check if product is already applied by user
                            let removeDuplicateProdCode =
                                this.duplicateProdCode.includes(item.prodCode);

                            if (removeDuplicateProdCode === false) {
                                // Check for PG products to exclude (except BRP)
                                let isPGProduct = false;
                                if (item.prodTag) {
                                    try {
                                        const tags = parseJSON(item.prodTag);
                                        isPGProduct =
                                            Array.isArray(tags) &&
                                            tags.includes('PG') &&
                                            !tags.includes('BRP');
                                    } catch {
                                        isPGProduct = false;
                                    }
                                }

                                return !isPGProduct;
                            }
                            return false;
                        },
                    );
                    element.prodNameList = getNonDuplicateProducts;
                    this.matchedProductsTotal += element.prodNameList.length;
                    this.initialMatchedProdTotal = this.matchedProductsTotal;
                });

                if (this.isCGCFlow) {
                    const data = this.getTopFiProductsWithFilteredProduct(
                        this.matchedProductsList,
                    );

                    // Split Digital Bank products from the main recommendation list
                    this.recomProdList = data.filter(
                        (item) =>
                            item.prodNameList[0]?.prodCat !== 'DIGITAL BANK',
                    );

                    this.recomDigitalBankList = data.filter(
                        (item) =>
                            item.prodNameList[0]?.prodCat === 'DIGITAL BANK',
                    );

                    this.isRecommended = true;
                }
            }
            const initialArray = this.matchedProductsList;
            this.initialMatchedProductsList = this.nestedCopy(initialArray);
            if (this.matchedProductsTotal > 0) {
                this.noMatchedProducts = false;
            } else {
                this.noMatchedProducts = true;

                if (this.isCGCFlow) {
                    this.getProductList();
                } else {
                    if (this.isBRPFlow && this.noMatchedProducts) {
                        this.isBRPNoMatchFlow = true;
                        this.isBRPFlow = false;
                    }
                }
            }
            this.apiResponse = true;
        } else if (this.statusCode === 400 || this.statusCode === 404) {
            //no matched products
            this.noMatchedProducts = true;
            this.apiResponse = true;
            if (this.isCIDBFlow) {
                this.isCIDBNoMatchFlow = true;
                this.isCIDBFlow = false;
            }
            if (this.isBRPFlow) {
                this.isBRPNoMatchFlow = true;
                this.isBRPFlow = false;
            }
            if (this.isCGCFlow) {
                this.getProductList();
            }
        }

        this.setupGAEvents();
    }

    async getProductList() {
        try {
            // stop using getApplicationProductList, use getNoMatchRecommendation
            const res = await lastValueFrom(
                this.applicationService.getNoMatchRecommendation(),
            );

            const p2pProducts = [];

            res.map((partner) => {
                if (partner?.products.length > 0) {
                    let newPrt = { ...partner, prodNameList: [] };
                    let isp = false;
                    partner?.products.map((product) => {
                        if (
                            product.prodCat === 'P2P' ||
                            product.prodCat === 'DIGITAL BANK'
                        ) {
                            isp = true;
                            newPrt.prodNameList.push(product);
                        }
                    });
                    if (isp) {
                        p2pProducts.push(newPrt);
                    }
                }
            });

            await this.getP2pCaseStatus(this.regBrnNum);
            this.p2pProducts = p2pProducts.filter((prod) => {
                if (!prod?.products) return false;

                // Filter out products that have prodCode in duplicateP2pProdCode
                prod.products = prod.products.filter(
                    (product) =>
                        !this.duplicateP2pProdCode.includes(product.prodCode),
                );

                // Also filter prodNameList if it exists
                if (prod.prodNameList) {
                    prod.prodNameList = prod.prodNameList.filter(
                        (product) =>
                            !this.duplicateP2pProdCode.includes(
                                product.prodCode,
                            ),
                    );
                }

                // Only keep the partner if they still have products after filtering
                return prod.products.length > 0;
            });

            // Split P2P products into regular P2P and Digital Bank categories
            const regularP2P = [];
            const digitalBankP2P = [];

            this.p2pProducts.forEach((prod) => {
                const regularProducts = prod.prodNameList.filter(
                    (product) => product.prodCat === 'P2P',
                );
                const digitalBankProducts = prod.prodNameList.filter(
                    (product) => product.prodCat === 'DIGITAL BANK',
                );

                if (regularProducts.length > 0) {
                    regularP2P.push({
                        ...prod,
                        prodNameList: regularProducts,
                    });
                }

                if (digitalBankProducts.length > 0) {
                    digitalBankP2P.push({
                        ...prod,
                        prodNameList: digitalBankProducts,
                    });
                }
            });

            // Update p2pProducts to only contain regular P2P products
            this.p2pProducts = regularP2P;

            // Add digital bank products to recomDigitalBankList if it doesn't exist
            if (!this.recomDigitalBankList) {
                this.recomDigitalBankList = [];
            }
            this.recomDigitalBankList = [
                ...this.recomDigitalBankList,
                ...digitalBankP2P,
            ];

            // Calculate total available P2P products after filtering
            this.matchedp2pProdTotal = 0;
            this.p2pProducts.forEach((prod) => {
                this.matchedp2pProdTotal += prod.prodNameList.length;
            });
            this.recomDigitalBankList.forEach((prod) => {
                this.matchedp2pProdTotal += prod.prodNameList.length;
            });

            this.noAvailableOptions =
                this.p2pProducts.length + this.recomDigitalBankList.length
                    ? false
                    : true;
        } catch (err) {
            this.toastr.error(err.error.message);
        }
    }

    onSelectNoMatchedProd(item: any) {
        const { isSelected, prodCode } = item;
        const msg = {
            en: 'To proceed with Alternate Financing Products, your previous selection will be deselected.',
            bm: 'Untuk meneruskan dengan pilihan Produk Pembiayaan Alternatif, pilihan Penasihat Kewangan anda akan dinyahpilih.',
        };
        if (isSelected) {
            this.selectedProducts.push({
                prodCode: prodCode,
            });
            this.prodArr.push(prodCode);
            if (this.fASelected) {
                this.fASelected = false;
                this.toastr.warning(
                    this.selectedLanguage === 'en' ? msg.en : msg.bm,
                );
            }
        } else {
            const temp = this.selectedProducts.filter(
                (item) => item.prodCode !== prodCode,
            );
            this.selectedProducts = temp;
            const tm = this.prodArr.filter((item) => item !== prodCode);
            this.prodArr = tm;
        }

        this.limitExceeded = this.selectedProducts.length > 5;
        this.P2P_ProductsTotal = this.selectedProducts.length;
    }

    onSelectFA() {
        this.fASelected = !this.fASelected;
        const msg = {
            en: 'To proceed with Financial Advisory, your previous selection will be deselected.',
            bm: 'Untuk meneruskan dengan Penasihat Kewangan, pilihan produk anda akan dinyahpilih.',
        };
        if (this.fASelected && this.prodArr.length > 0) {
            this.toastr.warning(
                this.selectedLanguage === 'en' ? msg.en : msg.bm,
            );
        }

        this.selectedProducts.length = 0;
        this.P2P_ProductsTotal = 0;
        this.prodArr.length = 0;
        this.limitExceeded = false;
    }

    onSubmitNoMatchedProduct() {
        this.getTranslations();
        if (
            !this.fASelected &&
            (!this.selectedProducts || this.selectedProducts.length === 0)
        ) {
            this.toastr.error(this.selectfAOrP2P);
            return;
        }
        if (!this.fASelected) {
            this.checkRecProdSelection();
        } else {
            this.onSubmitNoMatchActual();
        }
    }

    onSubmitNoMatchActual() {
        this.disableSubmitBtn = true;
        let obj = {
            caseId: this.caseId,
        };
        if (this.fASelected) {
            obj['isFATDSCase'] = true;
        } else {
            let selectionArray = this.selectedProducts.map(({ prodCode }) => ({
                prodCode,
            }));
            obj['selection'] = selectionArray;
        }
        this.apiResponse = false;
        this.applicationService.submission(obj).subscribe({
            next: (res) => {
                this.apiResponse = true;
                let submissionData = parseJSON(res);
                this.router.navigate(['/status'], {
                    state: {
                        submissionDetails: submissionData,
                        caseId: this.caseId,
                        fASelected: this.fASelected,
                    },
                });
            },
            error: (err) => {
                this.apiResponse = true;
                this.disableSubmitBtn = false;
                let reason = err.error.reason;
                let duplicateProdReason = 'Duplicate Product';
                if (
                    reason.trim().toLowerCase() ===
                    duplicateProdReason.trim().toLowerCase()
                ) {
                    let duplicateErr1: any;
                    let duplicateErr2: any;
                    if (this.selectedLanguage == 'bm') {
                        duplicateErr1 = 'Anda telah memohon produk berikut: ';
                        duplicateErr2 =
                            '. Sila pilih produk lain atau batalkan pilihan semasa.';
                    } else if (this.selectedLanguage == 'en') {
                        duplicateErr1 =
                            "You've already applied for the following product(s): ";
                        duplicateErr2 =
                            '. Please choose a different product or deselect the current selections.';
                    }
                    let duplicateProd = err.error.data;
                    let productName = [];
                    this.p2pProducts.forEach((item) => {
                        item.prodNameList.forEach((product) => {
                            if (duplicateProd.includes(product.prodCode)) {
                                productName.push(product.productName);
                            }
                        });
                    });
                    let productNameString = productName.join(', ');
                    let duplicateErrMsg =
                        duplicateErr1 + productNameString + duplicateErr2;
                    this.toastr.error(duplicateErrMsg, '', {
                        timeOut: Number(environment.toastrTimeoutDup),
                        extendedTimeOut: Number(environment.toastrTimeoutDup),
                        closeButton: true,
                    });
                } else {
                    this.toastr.error(err.error.message);
                }
            },
        });
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
        this.getTranslations();
    }

    getImgUrl(img) {
        if (!isEmpty(img)) {
            return img;
        } else if (isEmpty(img)) {
            let url = '';
            if (this.selectedLanguage == 'bm') {
                url = '/assets/images/image_not_available_bm.webp';
            } else if (this.selectedLanguage == 'en') {
                url = '/assets/images/image_not_available_en.webp';
            }
            return url;
        }
    }

    onImgErr(event) {
        this.imgRetries++;
    }

    toggleFilter(e) {
        event.stopPropagation();
        if (this.isFilterOpen == e) {
            this.closeDropdown();
            return;
        }
        this.isFilterOpen = e;
        this.isSortbyOpen = false;
    }

    toggleSortBy(e) {
        if (this.isSortbyOpen === e) {
            this.closeSortBy();
            return;
        }
        this.isSortbyOpen = e;
        this.isFilterOpen = false;
    }

    closeSortBy() {
        this.isFilterOpen = false;
    }

    closeDropdown() {
        this.isSortbyOpen = false;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    addIfNotExists(value: any, array: any[]): void {
        // Check if the value is not already present in the array
        if (array.indexOf(value) === -1) {
            // If not present, add the value to the array
            array.push(value);
        }
    }

    removeProviders(prodCat) {
        let removeIndex = this.filteredProducts.findIndex(
            (item) => item === prodCat,
        );
        if (removeIndex !== -1) {
            this.filteredProducts.splice(removeIndex, 1);
        }
    }

    onFilterProduct(event, prodCategory) {
        let prodCat = prodCategory;
        this.checkboxStates[prodCat] = event.target.checked;

        if (prodCat === 'Provider') {
            this.checkboxStates['BANK'] = event.target.checked;
            this.checkboxStates['P2P'] = event.target.checked;
            this.checkboxStates['CGC'] = event.target.checked;
            this.checkboxStates['DIGITAL BANK'] = event.target.checked;
            if (event.target.checked) {
                this.addIfNotExists('BANK', this.filteredProducts);
                this.addIfNotExists('P2P', this.filteredProducts);
                this.addIfNotExists('CGC', this.filteredProducts);
                this.addIfNotExists('DIGITAL BANK', this.filteredProducts);
            } else {
                this.removeProviders('BANK');
                this.removeProviders('P2P');
                this.removeProviders('CGC');
                this.removeProviders('DIGITAL BANK');
            }

            this.matchedProductsList = this.nestedCopy(
                this.initialMatchedProductsList,
            );

            // Apply all filters at once
            this.filteredProducts.forEach((filter) => {
                this.filterProductFn(filter);
            });
        } else if (prodCat === 'Type') {
            this.checkboxStates['isIslamic'] = event.target.checked;
            this.checkboxStates['isConventional'] = event.target.checked;
            if (event.target.checked) {
                this.addIfNotExists('isIslamic', this.filteredProducts);
                this.addIfNotExists('isConventional', this.filteredProducts);
            } else {
                this.removeProviders('isIslamic');
                this.removeProviders('isConventional');
            }
            this.matchedProductsList = this.nestedCopy(
                this.initialMatchedProductsList,
            );

            // Apply all filters at once
            this.filteredProducts.forEach((filter) => {
                this.filterProductFn(filter);
            });
        } else {
            if (event.target.checked) {
                this.filteredProducts.push(prodCat);
            } else {
                if (
                    prodCat === 'BANK' ||
                    prodCat === 'P2P' ||
                    prodCat === 'CGC' ||
                    prodCat === 'DIGITAL BANK'
                ) {
                    this.checkboxStates['Provider'] = false;
                }
                if (prodCat === 'isIslamic' || prodCat === 'isConventional') {
                    this.checkboxStates['Type'] = false;
                }
                let removeIndex = this.filteredProducts.findIndex(
                    (item) => item === prodCat,
                );
                if (removeIndex !== -1) {
                    this.filteredProducts.splice(removeIndex, 1);
                }
            }

            // Reset to the original list before applying filters
            this.matchedProductsList = this.nestedCopy(
                this.initialMatchedProductsList,
            );

            // Apply all filters at once
            this.filteredProducts.forEach((filter) => {
                this.filterProductFn(filter);
            });

            if (
                this.filteredProducts.includes('BANK') &&
                this.filteredProducts.includes('P2P') &&
                this.filteredProducts.includes('CGC') &&
                this.filteredProducts.includes('DIGITAL BANK')
            ) {
                this.checkboxStates['Provider'] = true;
            }
            if (
                this.filteredProducts.includes('isIslamic') &&
                this.filteredProducts.includes('isConventional')
            ) {
                this.checkboxStates['Type'] = true;
            }
        }

        // Update the matchedProductsTotal with the filtered length of prodNameList
        this.updateMatchedProductsTotal();
    }

    filterProductFn(prodCat) {
        // Combine filters for Providers with OR relationship
        if (prodCat !== 'isIslamic' && prodCat !== 'isConventional') {
            let providerFilters = this.filteredProducts.filter(
                (item) => item !== 'isIslamic' && item !== 'isConventional',
            );

            if (providerFilters.length > 0) {
                this.matchedProductsList = this.matchedProductsList.filter(
                    (item) => {
                        return providerFilters.includes(
                            item.prodNameList[0].prodCat,
                        );
                    },
                );
            }
        }

        // Combine filters for Types with OR relationship
        if (prodCat === 'isIslamic' || prodCat === 'isConventional') {
            let typeFilter =
                this.filteredProducts.includes('isIslamic') &&
                this.filteredProducts.includes('isConventional');

            this.matchedProductsList = this.matchedProductsList
                .map((el) => {
                    const filteredProducts = el.prodNameList.filter((prod) => {
                        return (
                            typeFilter ||
                            prod.prodShariah ===
                                (prodCat === 'isIslamic' ? 'Y' : 'N')
                        );
                    });
                    return { ...el, prodNameList: filteredProducts };
                })
                .filter((el) => el.prodNameList.length > 0); // Remove FIs with no products after filtering
        }

        // Update matchedProductsTotal length after filtering products
        this.updateMatchedProductsTotal();
    }

    // Function to update the matchedProductsTotal length
    updateMatchedProductsTotal() {
        this.matchedProductsTotal = this.matchedProductsList.reduce(
            (total, fi) => total + fi.prodNameList.length,
            0,
        );
        if (this.noProductsOnFilter) {
            setTimeout(() =>
                this.noProductsOnFilter?.nativeElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                }),
            );
        }
    }

    updateFilteredProductsList() {
        // Reset to the original list before applying filters
        this.matchedProductsList = this.nestedCopy(
            this.initialMatchedProductsList,
        );

        // Apply all filters at once
        this.filteredProducts.forEach((filter) => {
            this.filterProductFn(filter);
        });
    }

    onSortProduct(index) {
        if (this.selectedSortBy == index) {
            this.selectedSortBy = -1;
        } else {
            this.selectedSortBy = index;
            this.sortProductFn();
        }
    }

    nestedCopy(array) {
        return Array.from(array);
    }

    sortProductFn() {
        if (this.selectedSortBy == 0) {
            this.matchedProductsList.sort(
                (a, b) =>
                    Number(b.prodInterestRate) - Number(a.prodInterestRate),
            );
        } else if (this.selectedSortBy == 1) {
            this.matchedProductsList.sort(
                (a, b) =>
                    Number(a.prodInterestRate) - Number(b.prodInterestRate),
            );
        } else if (this.selectedSortBy == 2) {
            this.matchedProductsList.sort(
                (a, b) => Number(b.prodTat) - Number(a.prodTat),
            );
        } else if (this.selectedSortBy == 3) {
            this.matchedProductsList.sort(
                (a, b) => Number(a.prodTat) - Number(b.prodTat),
            );
        }
    }

    isValidSelection() {
        let totallen =
            this.selectedProducts.length + this.selectedProductsCGC.length;
        if (totallen > 0 && totallen < 4) {
            if (this.selectedProductsCGC.length > 0) {
                this.disableSubmitBtn = false;
                this.selectedProductsCGC.forEach((item) => {
                    if (item.selectedBranch == null) {
                        this.disableSubmitBtn = true;
                        return;
                    }
                });
            } else {
                this.disableSubmitBtn = false;
            }
        } else {
            this.disableSubmitBtn = true;
        }
    }

    recommendMinProdSelection() {
        const isMobile = window.innerWidth < 768;
        const dialogRef = this.dialogRef.open(ReminderPopupComponent, {
            width: isMobile ? '90vw' : '445px',
            maxWidth: isMobile ? '90vw' : 'none',
            panelClass: 'reminder-popup',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result && result == 'continue') {
                if (this.matchedProductsTotal > 0 && !this.noMatchedProducts) {
                    this.onSubmit();
                } else if (this.noMatchedProducts) {
                    this.onSubmitNoMatchActual();
                }
            }
        });
    }

    checkRecProdSelection() {
        if (!this.noMatchedProducts) {
            if (
                this.matchedProductsTotal >= 6 &&
                this.selectedProducts.length < 6
            ) {
                this.recommendMinProdSelection();
            } else {
                this.onSubmit();
            }
        } else if (this.noMatchedProducts) {
            if (
                this.p2pProducts.length >= 6 &&
                this.selectedProducts.length < 6
            ) {
                this.recommendMinProdSelection();
            } else {
                this.onSubmitNoMatchActual();
            }
        }
    }

    onSubmit() {
        this.disableSubmitBtn = true;
        this.selectedProducts.forEach((element) => {
            if (this.isBRPFlow) {
                if (element.prodDetails.fiProd == 'IFBU') {
                    element.branchEmail = this.selectedBrpBranches?.email;
                }
                element.branchCode = this.selectedBrpBranches?.branchCode;
                element.officerEmail = this.selectedBrpOfficers?.officerEmail;
                element.officerName = this.selectedBrpOfficers?.officerName;
                element.officerUserName =
                    this.selectedBrpOfficers?.officerUserName;
                if (
                    element.prodDetails.branchActive === 'Y' &&
                    isEmpty(element.branchName)
                ) {
                    element.branchName = this.selectedBrpBranches.branchName;
                }
            } else if (
                !this.isBRPFlow &&
                element.prodDetails.fiProd == 'IFBU'
            ) {
                element.officerName = this.selectedBranchOfficerName;
                element.officerEmail = this.selectedBranchOfficerEmail;
                element.officerUserName =
                    this.selectedBrpOfficers?.officerUserName ||
                    this.selectedBranchOfficerUserName ||
                    this?.bkData?.officerUsername;
            }
        });

        let selectionArray: any = this.selectedProducts.map(
            ({
                prodCode,
                branchName,
                officerName,
                officerUserName,
                officerEmail,
                branchCode,
                branchEmail,
            }) => {
                let obj = {
                    prodCode,
                };

                if (branchName) obj['selectedBranch'] = branchName;
                if (officerName) obj['officerName'] = officerName;
                if (officerUserName) obj['officerUserName'] = officerUserName;
                if (officerEmail) obj['officerEmail'] = officerEmail;
                if (branchCode) obj['branchCode'] = branchCode;
                if (branchEmail) obj['branchEmail'] = branchEmail;

                return obj;
            },
        );

        // selectionArray.forEach((element) => {
        //     if (isEmpty(element.branchEmail)) {
        //         delete element.branchEmail;
        //     }
        // });

        this.selectedProductsDocsCond = this.selectedProducts.map(
            ({ uploadDocs }) => ({ uploadDocs }),
        );

        let matchedProdReObj = {
            caseId: this.caseId,
            selection: selectionArray,
        };
        const payLoad = {
            caseId: this.caseId,
            fromResume: this.fromResume,
            productName: this.productName,
            objectRequested: matchedProdReObj,
            docsCondition: this.selectedProductsDocsCond,
        };

        // console.log('payload', payLoad);
        // return false;
        this.disableSaveDraft = true;
        this.router.navigate(['/application-document-upload'], {
            state: {
                caseId: this.caseId,
                fromResume: this.fromResume,
                productName: this.productName,
                objectRequested: matchedProdReObj,
                docsCondition: this.selectedProductsDocsCond,
            },
        });
    }

    goToProductsList() {
        this.router.navigate(['/business-financing']);
    }

    onClickSupport() {
        this.router.navigate(['/contact-us']);
        localStorage.setItem('support-btn', 'true');
    }

    goToHome() {
        this.router.navigate(['']);
    }

    onSubmitMatchedProduct() {
        this.getTranslations();

        if (!this.selectedProducts || this.selectedProducts.length === 0) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.toastr.error(this.productMinMaxError);
            return;
        }

        if (this.isBRPFlow) {
            this.onSubmit();
        } else if (!this.isBRPFlow) {
            // For VALIDATION: Count Digital Bank + Bank + CGC together (max 3)
            let totalBankingProducts =
                this.bankProductsTotal + this.DigitalBanks_ProductsTotal;
            if (totalBankingProducts > 3) {
                this.toastr.error(this.maxBankSelectionError);
                return;
            }
            this.checkRecProdSelection();
        }
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }

    getTopFiProductsWithFilteredProduct(data: any[]) {
        const parseNumber = (val: string) => {
            const num = parseFloat(val);
            return isNaN(num) ? Infinity : num;
        };

        const flattened = data.flatMap((fi) =>
            (fi.prodNameList || []).map((product) => ({
                originalFi: fi,
                matchedProduct: product,
            })),
        );

        // Top 3 non-P2P and non-Digital Bank products with lowest interest rate
        const nonP2PTop3 = flattened
            .filter(
                ({ matchedProduct }) =>
                    matchedProduct.prodCat !== 'P2P' &&
                    matchedProduct.prodCat !== 'DIGITAL BANK',
            )
            .sort(
                (a, b) =>
                    parseNumber(a.matchedProduct.prodInterestRate) -
                    parseNumber(b.matchedProduct.prodInterestRate),
            )
            .slice(0, 3)
            .map(({ originalFi, matchedProduct }) => ({
                ...originalFi,
                prodNameList: [matchedProduct],
            }));

        // Top 3 P2P products with lowest TAT
        const p2pTop3 = flattened
            .filter(({ matchedProduct }) => matchedProduct.prodCat === 'P2P')
            .sort(
                (a, b) =>
                    parseNumber(a.matchedProduct.prodTat) -
                    parseNumber(b.matchedProduct.prodTat),
            )
            .slice(0, 3)
            .map(({ originalFi, matchedProduct }) => ({
                ...originalFi,
                prodNameList: [matchedProduct],
            }));

        // Top 3 Digital Bank products with lowest processing time (TAT)
        const digitalBankTop3 = flattened
            .filter(({ matchedProduct }) => {
                return matchedProduct.prodCat === 'DIGITAL BANK';
            })
            .sort(
                (a, b) =>
                    parseNumber(a.matchedProduct.prodTat) -
                    parseNumber(b.matchedProduct.prodTat),
            )
            .slice(0, 3)
            .map(({ originalFi, matchedProduct }) => ({
                ...originalFi,
                prodNameList: [matchedProduct],
            }));

        return [...nonP2PTop3, ...p2pTop3, ...digitalBankTop3];
    }

    hasTransferTag(product: any): boolean {
        if (!product.prodTag) return false;
        try {
            const tags = parseJSON(product.prodTag);
            return Array.isArray(tags) && tags.includes('Fast Transfer');
        } catch {
            return false;
        }
    }
}
